// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 957) return "static/chunks/957-dc98853d26e5abf1.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 70 ? "8012d7e2" : chunkId) + "." + {"70":"4eef0b69b31d7432","94":"85b14086a6832cb9","289":"3ce70a76bd1df7c2","829":"2cf3f5bb7be137e2","959":"b96cf57b6c76af9a"}[chunkId] + ".js";
};